import { useEffect, useState } from "react";
import { getTransactionTypeList } from "utils/api/lookupApi";
import { OptionRenderType } from "controls/global/stewart-checkbox/StewartAutocompleteWithCheckboxes";

// Transaction-type dropdown options sourced from /lookup/GetPIList/TransactionType.
// Label = TransactionTypeName, value = TransactionTypeCode — the code matches the
// PolicyTransaction record's TransactionTypeCode field for pre-selection.
export function useTransactionTypeOptions(): OptionRenderType[] {
  const [options, setOptions] = useState<OptionRenderType[]>([]);
  useEffect(() => {
    let mounted = true;
    getTransactionTypeList()
      .then((rows) => {
        if (!mounted) return;
        const list = Array.isArray(rows) ? rows : [];
        setOptions(
          list.map((t) => ({
            label: t.TransactionTypeName,
            value: t.TransactionTypeCode,
          }))
        );
      })
      .catch(() => {
        if (mounted) setOptions([]);
      });
    return () => {
      mounted = false;
    };
  }, []);
  return options;
}
